import { Fragment, useState } from "react";
import React from "react";
import {
  Dialog,
  Menu,
  Transition,
  Listbox,
  Combobox,
  Disclosure,
} from "@headlessui/react";

import { Link, Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  ArchiveIcon,
  XIcon,
  XCircleIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";

const notificationMethods = [
  { id: "1", title: "1" },
  { id: "2", title: "2" },
  { id: "3", title: "3" },
  { id: "4", title: "4" },
  { id: "5", title: "5" },
];

const userNavigation = [{ name: "Logout", href: "Login" }];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class CustomerfeedbackModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      message:"Successfully Saved",
      logoutRedirect: false,
      success: false,
      redirect: false,
      customerList: [],
      customer_id: "",
      query: "",
      id: "",
      status:true,
      selectedPerson: "",
      feedback_question_answer: [],
      feedback_from_where_id:3,
      QuestionList: [],
      error_list: [],
      loader: "animate-pulse",
      existingCustomer:false,
      existing_customer:0,
      feedbackstatusList:[],
      feedbackcallstatusList:[],
      employeeList:[],
      name:"",
      phone:"",
      vehicle:"",
      service_type:"",
      call_status_id:"",
      feedback_status_id:"",
      employee_id:"",
      description:"",
    };
    this.handleInput = this.handleInput.bind(this);
  }
  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };

  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };

  handleInputOne = (e) => {
    this.setState({
      query: e.target.value,
    });
  };

  handleInputCutomer = (e) => {
    this.setState({
      selectedPerson: e,
    });
    this.state.id = e.id_crypt;
    

    this.setState({ id: this.state.id });
    this.setState({ customer_id: e.id });
  };

  handleChangeCheckboxforExistingcustomer=(e)=>{
    
    this.setState({
      existingCustomer: !this.state.existingCustomer,
    });
    
    if(this.state.existingCustomer){
      this.state.existing_customer=0;
      this.state.feedback_from_where_id=3;
      console.log("New");
      this.setState({customer_id:0,feedback_from_where_id:this.state.feedback_from_where_id,existing_customer:this.state.existing_customer});

    }
    if(!this.state.existingCustomer){
      console.log("existing");
      this.state.existing_customer=1;
      this.state.feedback_from_where_id=2;
      this.setState({feedback_from_where_id:this.state.feedback_from_where_id,existing_customer:this.state.existing_customer});
      console.log(this.state.existing_customer);
  }
}

  componentDidMount() {
    this.state.feedback_question_answer = [];
    this.setLoaderFunction();
    const token = localStorage.getItem("token");

    const res1 = axios
      .get("public/api/feedback/questions", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res1) => {
        this.state.feedback_question_answer = [];
        res1.data.feedback_questions.map((q) => {
          this.state.feedback_question_answer.push({
            question: q.question,
            answer: "",
            rating: 1,
          });
        });
        this.setState({
          feedback_question_answer:
            this.state.feedback_question_answer,
        });
      });

    this.state.customerList = [];
    const res = axios
      .get("public/api/customers", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ customerList: res.data.customers });
        this.setState({ opencustomer: false });
      });

      const res2 = axios
        .get("public/api/feedback/status", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res2) => {
          this.setState({ feedbackstatusList: res2.data.feedback_status });
        });
        
        const res3 = axios
        .get("public/api/call/status", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res3) => {
          this.setState({ feedbackcallstatusList: res3.data.call_status });
        });
        

        const res4 = axios
        .get("public/api/employees", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res4) => {
          this.setState({ employeeList: res4.data.employees });
        });
        

    this.closeLoaderFuncion();
  }

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleInputwarehouseF = (e) => {
    this.props.handleInputwarehouseA(e);
  };

  saveItem = async (e) => {
    e.preventDefault();
    this.setLoaderFunction();
    
        var token = localStorage.getItem("token");
        const headers = {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        };

        const res = await axios.post(
          "public/api/feedbacks/question/answer/store",
          this.state,
          {
            headers,
          }
        );

        if (res.data.success) {
          this.closeLoaderFuncion();
          this.setState({ showmsg: true });
          this.handleInputwarehouseF(res.data.success);
          setTimeout(
            function () {
              //Start the timer
              this.setState({ redirect: true }); //After 1 second, set render to true
            }.bind(this),
            1000
          );
        } else {
          this.closeLoaderFuncion();

          /*
          if(res.data.message!=""){
            this.setState({message:res.data.message,status:false});
            this.setState({ showmsg: true });
          }*/

          
          this.setState({ error_list: res.data.data });
          //this.setState({ show: true })
        }


    this.closeLoaderFuncion();
  };

  update = async (e) => {
    e.preventDefault();
    this.setLoaderFunction();
    console.log(this.state.invoiceId);
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post(
      "public/api/invoice/feedback/update/" + this.state.invoiceId,
      this.state,
      {
        headers,
      }
    );

    if (res.data.success) {
      this.closeLoaderFuncion();
      this.setState({ showmsg: true });
      this.handleInputwarehouseF(res.data.success);
      setTimeout(
        function () {
          //Start the timer
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.closeLoaderFuncion();

      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
    this.closeLoaderFuncion();
  };

  handleanswer = (index) => (e) => {
    this.state.feedback_question_answer[index].answer = e.target.value;
    this.setState({
      feedback_question_answer:
        this.state.feedback_question_answer,
    });
  };
  handlerating = (index) => (e) => {
    this.state.feedback_question_answer[index].rating = e.target.value;
    this.setState({
      feedback_question_answer:
        this.state.feedback_question_answer,
    });
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }
    let ans = 1;
const newcustomer= () => (<><div className="col-span-6 sm:col-span-6 lg:col-span-2">
                          <label
                            htmlFor="name"
                            className="block text-sm font-medium text-gray-700"
                          >
                            <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                              Name
                            </span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            id="name"
                            onChange={this.handleInput}
                            autoComplete="name"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="name-error"
                          >
                            {this.state.error_list.name}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="phone_no"
                            className="block text-sm font-medium text-gray-700"
                          >
                            <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                              Phone
                            </span>
                          </label>
                          <input
                            type="text"
                            name="phone_no"
                            id="phone_no"
                            onChange={this.handleInput}
                            autoComplete="phone_no"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="phone_no-error"
                          >
                            {this.state.error_list.phone_no}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="vehicle"
                            className="block text-sm font-medium text-gray-700"
                          >
                            <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                              Vehicle
                            </span>
                          </label>
                          <input
                            type="text"
                            name="vehicle"
                            id="vehicle"
                            onChange={this.handleInput}
                            autoComplete="vehicle"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="vehicle-error"
                          >
                            {this.state.error_list.vehicle}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="description"
                            className="block text-sm font-medium text-gray-700"
                          >
                            <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                              Description
                            </span>
                          </label>
                          <input
                            type="text"
                            name="description"
                            id="description"
                            onChange={this.handleInput}
                            autoComplete="description"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="description-error"
                          >
                            {this.state.error_list.description}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="service_type"
                            className="block text-sm font-medium text-gray-700"
                          >
                            <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                              Service Type
                            </span>
                          </label>
                          <input
                            type="text"
                            name="service_type"
                            id="service_type"
                            onChange={this.handleInput}
                            autoComplete="service_type"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="service_type-error"
                          >
                            {this.state.error_list.service_type}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="call_status"
                            className="block text-sm font-medium text-gray-700"
                          >
                            <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                              Call status
                            </span>
                          </label>
                          <input
                            type="text"
                            name="call_status"
                            id="call_status"
                            onChange={this.handleInput}
                            autoComplete="call_status"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="call_status-error"
                          >
                            {this.state.error_list.call_status}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="feedback_status"
                            className="block text-sm font-medium text-gray-700"
                          >
                            <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                              Feedback status
                            </span>
                          </label>
                          <input
                            type="text"
                            name="feedback_status"
                            id="feedback_status"
                            onChange={this.handleInput}
                            autoComplete="feedback_status"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="feedback_status-error"
                          >
                            {this.state.error_list.feedback_status}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="employee_name"
                            className="block text-sm font-medium text-gray-700"
                          >
                            <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                              Staff Name
                            </span>
                          </label>
                          <input
                            type="text"
                            name="employee_name"
                            id="employee_name"
                            onChange={this.handleInput}
                            autoComplete="employee_name"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="employee_name-error"
                          >
                            {this.state.error_list.employee_name}
                          </p>
                  </div>
                  </>
                  
                  ); 





    const filteredPeople =
      this.state.query === ""
        ? this.state.customerList
        : this.state.customerList.filter((customerList) => {
            return customerList.customer_display_name
              .toLowerCase()
              .includes(this.state.query.toLowerCase());
          });
    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
        <div className={this.state.overLay} aria-hidden="true" />
        <main className="flex-1">
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <h1 className="text-2xl font-semibold text-gray-900">
                Cusomter Feedback
              </h1>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              {/* Replace with your content */}

              <div className="hidden sm:block" aria-hidden="true">
                <div className="py-5">
                  <div className="border-t border-gray-200" />
                </div>
              </div>
              <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                <div className="md:grid md:gap-6">
                  <div className="mt-5 md:mt-0 md:col-span-2">
                  
                    <form onSubmit={this.saveItem}>
                    <div className="grid grid-cols-6 gap-6">
                    <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                        <fieldset className="space-y-5">
                          <legend className="sr-only"></legend>
                          <div className="relative flex items-start">
                            <div className="flex items-center h-5">
                              <input
                                id="existingCustomer"
                                aria-describedby="comments-description"
                                name="existingCustomer"
                                checked={this.state.checked}
                                onChange={this.handleChangeCheckboxforExistingcustomer}
                                type="checkbox"
                                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                              />
                            </div>
                            <div className="ml-3 text-sm">
                              <label
                                htmlFor="existingCustomer"
                                className="font-medium text-gray-700"
                              >
                                Existing Customer
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>


                      {this.state.existingCustomer?(<div className="col-span-6 sm:col-span-6 lg:col-span-6">
                        <Combobox
                          as="div"
                          name="customer_id"
                          value={this.state.selectedPerson}
                          onChange={this.handleInputCutomer}
                          required
                        >
                          <Combobox.Label className="block text-sm font-medium text-gray-700">
                            <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                              Customer
                            </span>
                          </Combobox.Label>
                          <div className="relative mt-1">
                            <Combobox.Input
                              className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                              onChange={this.handleInputOne}
                              displayValue={(cutomer) =>
                                typeof cutomer.customer_display_name !==
                                  "undefined" &&
                                cutomer.customer_display_name != null
                                  ? cutomer.customer_display_name
                                  : ""
                              }
                            />
                            <Combobox.Button className="absolute inset-y-0 right-9 flex items-center rounded-r-md px-2 focus:outline-none">
                              <SelectorIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                              />
                            </Combobox.Button>

                            {filteredPeople.length > 0 && (
                              <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                {filteredPeople.map((customer) => (
                                  <Combobox.Option
                                    key={customer.id_crypt}
                                    value={customer}
                                    className={({ active }) =>
                                      classNames(
                                        "relative cursor-default select-none py-2 pl-3 pr-9",
                                        active
                                          ? "bg-indigo-600 text-white"
                                          : "text-gray-900"
                                      )
                                    }
                                  >
                                    {({ active, selected }) => (
                                      <>
                                        <span
                                          className={classNames(
                                            "block truncate",
                                            selected && "font-semibold"
                                          )}
                                        >
                                          {customer.customer_display_name}
                                        </span>

                                        {selected && (
                                          <span
                                            className={classNames(
                                              "absolute inset-y-0 right-0 flex items-center pr-4",
                                              active
                                                ? "text-white"
                                                : "text-indigo-600"
                                            )}
                                          >
                                            <CheckIcon
                                              className="h-5 w-5"
                                              aria-hidden="true"
                                            />
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </Combobox.Option>
                                ))}
                              </Combobox.Options>
                            )}
                          </div>
                        </Combobox>
                        <p
                            className="mt-2 text-sm text-red-600"
                            id="name-error"
                          >
                            {this.state.error_list.customer_id}
                          </p>
                      </div>):(<><div className="col-span-6 sm:col-span-3 lg:col-span-2">
                          <label
                            htmlFor="name"
                            className="block text-sm font-medium text-gray-700"
                          >
                            <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                              Name
                            </span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            id="name"
                            onChange={this.handleInput}
                            autoComplete="name"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="name-error"
                          >
                            {this.state.error_list.name}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span- lg:col-span-2">
                         <label
                            htmlFor="phone"
                            className="block text-sm font-medium text-gray-700"
                          >
                            
                              Phone
                            
                          </label>
                          <input
                            type="text"
                            name="phone"
                            id="phone"
                            onChange={this.handleInput}
                            autoComplete="phone"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="phone-error"
                          >
                            {this.state.error_list.phone}
                          </p>
                  </div>
                  
                  </>)
                      }

                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="vehicle"
                            className="block text-sm font-medium text-gray-700"
                          >
                            
                              Vehicle
                            
                          </label>
                          <input
                            type="text"
                            name="vehicle"
                            id="vehicle"
                            onChange={this.handleInput}
                            autoComplete="vehicle"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="vehicle-error"
                          >
                            {this.state.error_list.vehicle}
                          </p>
                  </div>
                  
                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="service_type"
                            className="block text-sm font-medium text-gray-700"
                          >
                            
                              Service Type
                            
                          </label>
                          <input
                            type="text"
                            name="service_type"
                            id="service_type"
                            onChange={this.handleInput}
                            autoComplete="service_type"
                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="service_type-error"
                          >
                            {this.state.error_list.service_type}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="call_status_id"
                            className="block text-sm font-medium text-gray-700"
                          >
                            
                              Call status
                            
                          </label>
                          <select
                                id="call_status_id"
                                name="call_status_id"
                                onChange={this.handleInput}
                                autoComplete="call_status_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.feedbackcallstatusList.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="call_status_id-error"
                          >
                            {this.state.error_list.call_status_id}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="feedback_status_id"
                            className="block text-sm font-medium text-gray-700"
                          >
                            
                              Feedback status
                            
                          </label>
                          <select
                                id="feedback_status_id"
                                name="feedback_status_id"
                                onChange={this.handleInput}
                                autoComplete="feedback_status_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.feedbackstatusList.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="feedback_status_id-error"
                          >
                            {this.state.error_list.feedback_status_id}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                         <label
                            htmlFor="employee_id"
                            className="block text-sm font-medium text-gray-700"
                          >
                            
                              Staff Name
                            
                          </label>
                          <select
                                  id="employee_id"
                                  name="employee_id"
                                  onChange={this.handleInput}
                                  autoComplete="employee_id"
                                  className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                  <option value="">------</option>
                                  {this.state.employeeList.map((number) => (
                                    <option value={number.id}>
                                      {number.name}
                                    </option>
                                  ))}
                          </select>
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="employee_id-error"
                          >
                            {this.state.error_list.employee_id}
                          </p>
                  </div>
                  <div className="col-span-6 sm:col-span-6 lg:col-span-6">
                         <label
                            htmlFor="description"
                            className="block text-sm font-medium text-gray-700"
                          >
                            Description
                          </label>
                           <textarea
                            rows={2}
                            name="description"
                            onChange={this.handleInput}
                            id="description"
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            defaultValue={''}
                          />
                          <p
                            className="mt-2 text-sm text-red-600"
                            id="description-error"
                          >
                            {this.state.error_list.description}
                          </p>
                  </div>
                    </div>
                    
                      
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          <div className="grid grid-cols-1 gap-6">
                            {this.state.feedback_question_answer.map(
                              (quest, index) => (
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <p className="text-sm leading-5 text-gray-500">
                                    {index + 1 + "."}
                                    {quest.question}
                                  </p>
                                  <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                                    <fieldset className="mt-4" id={index}>
                                      <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                                        {notificationMethods.map(
                                          (q, qindex) => (
                                            <div
                                              key={ans++}
                                              onChange={this.handlerating(
                                                index
                                              )}
                                              className="flex items-center"
                                            >
                                              <input
                                                id={ans++}
                                                name={"rating" + index}
                                                type="radio"
                                                value={q.id}
                                                checked={q.id == quest.rating}
                                                defaultChecked={
                                                  q.id === quest.rating
                                                }
                                                className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                              />
                                              <label
                                                htmlFor={index}
                                                className="ml-3 block text-sm font-medium text-gray-700"
                                              >
                                                {q.id}
                                              </label>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </fieldset>
                                  </div>

                                  <div className="mt-3">
                                    <input
                                      type="text"
                                      name="answer"
                                      onChange={this.handleanswer(index)}
                                      id="answer"
                                      value={quest.answer}
                                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                      placeholder="Comments"
                                    />
                                  </div>
                                </div>
                              )
                            )}
                          </div>

                          <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                            <button
                              type="submit"
                              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                      
                    </form>
                     
                  </div>
                </div>
              </div>

              {/* /End replace */}
            </div>
          </div>
        </main>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      {this.state.status?
                    (<CheckCircleIcon
                      className="h-6 w-6 text-green-400"
                      aria-hidden="true"
                    />):(<XCircleIcon
                      className="h-6 w-6 text-red-400"/>
                      )  
                    }
                      
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.message}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false ,message:"",status:true});
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default CustomerfeedbackModal;
